import React, { useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";

export default function AgreementViewer({
  open,
  onClose,
  pdfBase64,
  generatedText,
  orgName,
  agreementType,
}) {
  const pdfContainerRef = useRef(null);

  useEffect(() => {
    if (!pdfBase64 || !pdfContainerRef.current) return;

    const pdfjsLib = window.pdfjsLib;

    pdfjsLib.GlobalWorkerOptions.workerSrc =
      `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

    let pdfDoc = null;

    const renderPDF = async () => {
      if (!pdfDoc) {
        const binary = Uint8Array.from(atob(pdfBase64), c => c.charCodeAt(0));

        const loadingTask = pdfjsLib.getDocument({
          data: binary,
        });

        pdfDoc = await loadingTask.promise;
      }

      pdfContainerRef.current.innerHTML = "";

      for (let pageNum = 1; pageNum <= pdfDoc.numPages; pageNum++) {
        const page = await pdfDoc.getPage(pageNum);

        const viewport = page.getViewport({ scale: 1 });

        const containerWidth =
          pdfContainerRef.current.offsetWidth >= 720
            ? pdfContainerRef.current.offsetWidth
            : 720;

        const scale = (containerWidth - 2) / viewport.width;
        const scaledViewport = page.getViewport({ scale });

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        canvas.height = scaledViewport.height;
        canvas.width = scaledViewport.width;

        pdfContainerRef.current.appendChild(canvas);

        await page.render({
          canvasContext: context,
          viewport: scaledViewport,
        }).promise;
      }
    };

    renderPDF();

    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        renderPDF();
      }, 300);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };

  }, [pdfBase64]);

  const handleDownload = () => {
    if (!pdfBase64) return;
  
    const fileName = `${orgName}_${agreementType}.pdf`;
  
    const link = document.createElement("a");
    link.href = `data:application/pdf;base64,${pdfBase64}`;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal
      show={open}
      onHide={onClose}
      size="xl"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>View Completed Agreement</Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="p-3 d-flex flex-column"
        style={{ height: "80vh" }}
      >
        <div className="pb-2 d-flex flex-column flex-lg-row justify-content-between align-items-lg-center border-bottom">
          <span>{generatedText || ""}</span>
          {(orgName && agreementType) && (
            <button className="m-0 mt-2 mt-lg-0 ms-lg-3 learnmore-btn" onClick={handleDownload}>
              Download Agreement
            </button>
          )
          }
        </div>

        <div
          ref={pdfContainerRef}
          style={{
            width: "100%",
            overflowY: "auto",
            flex: 1,
            border: "1px solid black",
            borderRadius: "8px",
            paddingTop: "20px",
          }}
        >
        </div>
      </Modal.Body>
    </Modal>
   );
}